import { SET_COUNT, CLEAR_COUNT } from './constants'

export function increaseCounter() {
    return { type: SET_COUNT }
}

export function clearCounter() {
    return { type: CLEAR_COUNT }
}



// WEBPACK FOOTER //
// ./src/features/Settings/data/display/actions.js